import Component from 'vue-class-component';
import {RegistrationVue} from '@/registration-vue';
import './address-entry.scss';
import * as _ from 'lodash';
import {AddressApiService, BasicAddress} from '@/services/generated/edge/info';

@Component({template: require('./address-entry.html')})
export class AddressEntryPage extends RegistrationVue {

  address = '';
  onAddressInput: Function;

  type = '';

  manualInput: boolean = false;

  addressLoading: boolean = false;

  autoCompleteAddresses: BasicAddress[] = [];

  manualAddress = {
    unit: '',
    streetNumber: '',
    streetName: '',
    deliveryServiceNumber: '',
    ruralDeliveryNumber: '',
    suburb: '',
    city: '',
    postcode: ''
  };

  constructor() {
    super();

    this.onAddressInput = _.debounce((e) => {
      this.address = e.target.value;
      this.autoCompleteAddress(e.target.value);
    }, 300);
  }

  autoCompleteAddress(address: string) {
    this.address = address;

    if (this.address.length >= 3) {
      this.addressLoading = true;
      AddressApiService.autocompleteAddress(this.address).then((addressCollection) => {
        this.addressLoading = false;
        this.autoCompleteAddresses = addressCollection.addresses;
      }).catch(() => {
        this.addressLoading = false;
      })
    }
  }

  selectAddress(address: BasicAddress) {
    this.addressStateModel.address = address.description;
    this.addressStateModel.pxid = address.id;
    this.addressStateModel.isManual = false;
    this.addressStateModel.manualAddress = {};
    this.navigate('clubcard-details-entry',  { returnFromAddressEntry: 'true' });
  }

  enterManualInput() {
    this.manualInput = true;
  }

  enterAutoInput() {
    this.address = '';
    this.manualInput = false;
  }

  created() {
    this.$validator.updateDictionary({
                                       en: {
                                         custom: {
                                           streetName: {
                                             required: 'Please enter your street name'
                                           },
                                           streetNumber: {
                                             required: 'Street number is required'
                                           },
                                           town: {
                                             required: 'Please enter your town'
                                           },
                                           postcode: {
                                             required: 'Please enter your postcode',
                                             digitsonly: 'Postcode needs to be digits only'
                                           }
                                         }
                                       }
                                     });
  }

  mounted (){
    this.type = this.$route.query.type;

    if (this.addressStateModel.isManual) {
      this.manualInput = true;
      this.manualAddress = _.clone(this.addressStateModel.manualAddress)
    } else {
      const addressInput = (<HTMLInputElement>this.$refs.addressInput);
      const initialValue = this.addressStateModel.address;

      if (addressInput) {
        addressInput.value = initialValue;

        setTimeout(() => {
          addressInput.focus();
        }, 500);
      }
    }
  }

  get addressStateModel () {
    return this.$store.state[this.type + 'Address'];
  }

  submitManualAddress() {
    if (this.manualInput) {
      this.doIfFormIsValid(() => {
        this.addressStateModel.address = '';
        this.addressStateModel.pxid = '';
        this.addressStateModel.isManual = true;
        this.addressStateModel.manualAddress = _.clone(this.manualAddress);

        this.navigate('clubcard-details-entry',  { returnFromAddressEntry: 'true' });
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/forms/address-entry/address-entry.ts